import React, {FC} from "react"

import {Deal} from "@irati/types"

import Cinema from "./Cinema"
import SingleProduct from "./SingleProduct"
import MultipleProducts from "./MultipleProducts"
import BirthdayBoxForm from "./BirthdayBoxForm"
import OpenValueProduct from "./OpenValueProduct"
import ProductTypes from "../../../constants/productTypes"
import getDealType from "./helpers/getDealType"
import birthdayBoxToProduct from "./helpers/birthdayBoxToProduct"

interface Props {
  deal: Deal
}

const DealProductForm: FC<Props> = ({deal}) => {
  const products = deal.productConfig.products
  const type = getDealType(deal)

  switch (type) {
    case ProductTypes.BIRTHDAY_BOX:
      return <BirthdayBoxForm deal={deal} products={birthdayBoxToProduct(deal)} />
    case ProductTypes.CINEMA:
      return <Cinema deal={deal} products={products} />
    case ProductTypes.SINGLE_PRODUCT:
      return <SingleProduct deal={deal} products={products} />
    case ProductTypes.SINGLE_PRODUCT_QUANTITY:
      return <SingleProduct deal={deal} products={products} allowMultipleQuantity />
    case ProductTypes.MULTIPLE_PRODUCTS:
      return <MultipleProducts deal={deal} products={products} />
    case ProductTypes.OPEN_VALUE_PRODUCT:
      return <OpenValueProduct deal={deal} products={products} />
    default:
      return null
  }
}

export default DealProductForm
